/* CT Parts Counter — shared runtime.
   Working model 2026-08-07 · warranty gate 8/13 · whole parts bucket gated
   8/19. The catalog (88 products: 33 merchandised + 55 warranty-gated,
   direct-link-only — every Replacement Part gates; support sends the links)
   is baked into assets/ct-catalog.json with real variant IDs and the real
   cart. Everything else is honestly flagged, never silently faked. */
(function () {
  'use strict';
  var CT = (window.CT = window.CT || {});

  /* ---------- catalog ---------- */
  var catalogPromise = null;
  CT.catalog = function () {
    if (!catalogPromise) {
      var url = (window.CT_CATALOG_URL || '/assets/ct-catalog.json');
      catalogPromise = fetch(url)
        .then(function (r) { if (!r.ok) throw new Error('catalog ' + r.status); return r.json(); })
        .then(function (data) {
          data.byHandle = {};
          data.products.forEach(function (p) { data.byHandle[p.handle] = p; });
          /* Warranty gate: `gated` products are direct-link-only. They live
             in their own map so every surface that iterates data.products or
             reads data.byHandle (search, homepage bands, complementary)
             excludes them by construction — only the PDP router resolves
             gatedByHandle. */
          data.gatedByHandle = {};
          (data.gated || []).forEach(function (p) { data.gatedByHandle[p.handle] = p; });
          return data;
        });
    }
    return catalogPromise;
  };

  /* ---------- money ---------- */
  CT.money = function (n) {
    if (n === null || n === undefined || isNaN(n)) return '';
    return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  CT.moneyShort = function (n) {
    var v = Math.round(Number(n));
    return '$' + v.toLocaleString('en-US');
  };
  /* Savings are FLOORED whole dollars everywhere — "Save $15", never
     "$15.01" and never a round-UP that overstates the saving (copy rule,
     round 3 8/18). Use for save amounts; moneyShort stays for anchors. */
  CT.moneyFloor = function (n) {
    if (n === null || n === undefined || isNaN(n)) return '';
    var v = Math.floor(Number(n));
    return '$' + v.toLocaleString('en-US');
  };

  /* ---------- toast ---------- */
  var toastEl = null, toastTimer = null;
  CT.toast = function (msg, ms) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ct-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, ms || 2600);
  };

  /* ---------- cart ---------- */
  CT.cartCount = function () {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-ct-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.toggleAttribute('hidden', c.item_count === 0);
      });
      return c.item_count;
    }).catch(function () { return 0; });
  };

  /* Real add for live variant IDs; visible flag for not-yet-imported products. */
  CT.addToCart = function (btn, variantId, qty, title) {
    if (variantId) {
      btn.disabled = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); });
        return r.json();
      }).then(function () {
        btn.disabled = false;
        flashAdded(btn, 'Added');
        CT.cartCount();
        CT.assertSupportRef(true); /* cart may not have existed at page load */
        document.dispatchEvent(new CustomEvent('ct:cart-changed')); /* promo ribbon re-checks code state */
        CT.toast((title || 'Item') + ' added to cart.');
      }).catch(function (err) {
        btn.disabled = false;
        CT.toast(err.message || 'Could not add to cart.');
      });
    }
    /* No variant id — should be unreachable since the 8/17 launch-flip put
       real variants behind every catalog entry; kept as an honest fallback
       for stale caches, with evergreen copy (the old "imports on 8/18" line
       aged out). */
    flashAdded(btn, 'Call to order');
    CT.toast('This item can’t be ordered online yet — call 864-973-7973 and we’ll take care of it.');
    return Promise.resolve();
  };
  function flashAdded(btn, label) {
    var prev = btn.textContent;
    btn.classList.add('is-added');
    btn.textContent = label;
    setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = prev; }, 1400);
  }

  /* Delegated: any [data-ct-atc] button, optional sibling .ct-qty input */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ct-atc]');
    if (btn) {
      e.preventDefault();
      var scope = btn.closest('[data-ct-atc-scope]') || btn.closest('.ct-card') || btn.closest('form') || document;
      var qtyInput = scope.querySelector('.ct-qty input');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      CT.addToCart(btn, btn.getAttribute('data-variant-id') || '', qty, btn.getAttribute('data-title') || '');
      return;
    }
    var step = e.target.closest('.ct-qty button');
    if (step) {
      e.preventDefault();
      var input = step.parentElement.querySelector('input');
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + (step.dataset.dir === 'down' ? -1 : 1));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var copy = e.target.closest('[data-ct-copy]');
    if (copy) {
      e.preventDefault();
      var text = copy.getAttribute('data-ct-copy');
      var done = function () {
        var wrap = copy.closest('.ct-partno');
        if (wrap) {
          wrap.classList.add('is-copied');
          var label = wrap.querySelector('.ct-micro');
          var old = label ? label.textContent : '';
          if (label) label.textContent = 'Copied';
          setTimeout(function () { wrap.classList.remove('is-copied'); if (label) label.textContent = old; }, 1200);
        }
      };
      if (navigator.clipboard) navigator.clipboard.writeText(text).then(done, done); else done();
    }
  });

  /* ---------- fitment — three states, never two ----------
     'yes'   → selected model is in the product's published fit list
     'maybe' → product has no model data (universal or unverified) OR no model chosen
     'no'    → product has an explicit list and the selection is not in it */
  CT.MODEL_KEY = 'ct-my-model';
  CT.getMyModel = function () { try { return localStorage.getItem(CT.MODEL_KEY) || ''; } catch (e) { return ''; } };
  CT.setMyModel = function (m) { try { m ? localStorage.setItem(CT.MODEL_KEY, m) : localStorage.removeItem(CT.MODEL_KEY); } catch (e) {} };
  CT.fitState = function (models, selected) {
    if (!selected) return 'unset';
    if (!models || !models.length) return 'maybe';
    return models.indexOf(selected) !== -1 ? 'yes' : 'no';
  };

  /* ---------- search over the baked catalog ---------- */
  CT.search = function (q, limit) {
    var terms = String(q || '').trim().toLowerCase();
    if (!terms) return Promise.resolve([]);
    var words = terms.split(/\s+/);
    return CT.catalog().then(function (data) {
      var scored = [];
      /* Search-only parts (Jenn, 10/8): gated parts are findable from the
         search bar and predictive dropdown, and nowhere else — grids, facets,
         tiles and nav still read data.products only. */
      data.products.concat(data.gated || []).forEach(function (p) {
        var hay = (p.title + ' ' + (p.sku || '') + ' ' + (p.models || []).join(' ') + ' ' + p.handle.replace(/-/g, ' ') + ' ' + (p.sub || '')).toLowerCase();
        var ok = words.every(function (w) { return hay.indexOf(w) !== -1; });
        if (!ok) return;
        var score = 0;
        if ((p.sku || '').toLowerCase() === terms) score += 100;
        if (p.title.toLowerCase().indexOf(terms) === 0) score += 40;
        if (p.title.toLowerCase().indexOf(terms) !== -1) score += 20;
        if ((p.sku || '').toLowerCase().indexOf(terms) !== -1) score += 30;
        score += Math.min(p.orders12 || 0, 30) / 3;
        scored.push([score, p]);
      });
      scored.sort(function (a, b) { return b[0] - a[0]; });
      return scored.slice(0, limit || 8).map(function (s) { return s[1]; });
    });
  };

  /* ---------- gated part-number escape hatch ----------
     A search that matches a warranty-gated service part's number must not
     read as broken search to the repeat-buyer audience — surface the support
     path instead of a silent zero. Matches SKUs only (what the counter
     audience types off the white label); never returns a product or URL.
     Callers use it only when the merchandised search returned nothing. */
  function normPart(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function partMatch(sku, nq) {
    var ns = normPart(sku);
    return ns.indexOf(nq) !== -1 || nq.indexOf(ns) !== -1;
  }
  CT.gatedLookup = function (q) {
    var nq = normPart(q);
    if (nq.length < 5) return Promise.resolve(null);
    return CT.catalog().then(function (data) {
      /* Never claim "Support only" for a fragment that also matches a
         MERCHANDISED part number — punctuation-free typing gets zero listed
         hits from CT.search (raw-haystack match), so without this guard a
         shared prefix like "cti004" would falsely route buyers of listed
         parts to support (8/13 review find). Uniquely-gated numbers only. */
      var listedHit = data.products.some(function (p) { return p.sku && partMatch(p.sku, nq); });
      if (listedHit) return null;
      var hits = (data.gatedSkus || []).filter(function (sku) { return partMatch(sku, nq); });
      return hits.length ? { skus: hits } : null;
    }).catch(function () { return null; });
  };

  /* ---------- support-link provenance (?ref=support) ----------
     Service-part links sent by Clear Touch Support carry ?ref=support; log it
     as a cart attribute so the order records how the buyer arrived. Sticky
     for the tab session, and re-asserted after a real add in case the cart
     was created after landing. */
  var REF_KEY = 'ct-ref-support';
  try {
    if (new URLSearchParams(location.search).get('ref') === 'support') sessionStorage.setItem(REF_KEY, '1');
  } catch (e) { /* no-op */ }
  function hasSupportRef() {
    try { return sessionStorage.getItem(REF_KEY) === '1'; } catch (e) { return false; }
  }
  var refAsserted = false;
  CT.assertSupportRef = function (force) {
    if (!hasSupportRef() || (refAsserted && !force)) return;
    refAsserted = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ct_ref: 'support' } })
    }).catch(function () { refAsserted = false; });
  };

  /* ---------- product URL ---------- */
  CT.productUrl = function (p) { return '/products/' + p.handle; };

  document.addEventListener('DOMContentLoaded', function () {
    CT.cartCount();
    CT.assertSupportRef();
  });
})();
